import React, { useEffect, useRef } from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from "ag-grid-react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';

export const itemColdefs = [
    {
        headerCheckboxSelection: true,
        checkboxSelection: true,
        width: 50,
        pinned: 'left',
        suppressSizeToFit: true
    },
    {
        field: "drawingNo",
        headerName: "Drawing no",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
    {
        field: "materialType",
        headerName: "Item type",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "itemName",
        headerName: "Item details",
        minWidth: window.innerWidth * 0.2,
        flex: 1.5,
        filter: true,
    },
    {
        field: "inwardQuantity",
        headerName: "Inward quantity",
        minWidth: window.innerWidth * 0.07,
        flex: 0.6,
        filter: true,
    },
    {
        field: "rejectQuantity",
        headerName: "Reject quantity",
        minWidth: window.innerWidth * 0.07,
        flex: 0.6,
        filter: true,
    },
    {
        field: "reworkQuantity",
        headerName: "Rework quantity",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "passQuantity",
        headerName: "Pass quantity",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "status",
        headerName: "Status",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "tc",
        headerName: "TC",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "attachment",
        headerName: "Attachment",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "remarks",
        headerName: "Remarks",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
];

export const MaterialTestingPopup = (props) => {

    const gridRef = useRef();

    return (
        <ModalBasic
            id="material-testing"
            classParams="!w-[80%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Material testing details</span>
                <div className='item-grp grid grid-cols-6 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp'>
                        <label>Sr no</label>
                        <TextInput type='text'
                            id='testingNo' name='testingNo'
                            value={props.materialObject.testingNo}
                            handleChange={(event) => props.handleChange(event, 'testingNo')}
                            className={props.validState?.error?.testingNo !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Date</label>
                        <TextInput type='date'
                            id='testingDate' name='testingDate'
                            value={props.materialObject.testingDate}
                            handleChange={(event) => props.handleChange(event, 'testingDate')}
                            className={props.validState?.error?.testingDate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Select material inward</label>
                        <MultiSelectDropdown
                            drpIdentity="Select material"
                            options={props.materialObject.materialList}
                            value={props.materialObject.idMaterialInward ? props.materialObject.materialList.find(x => x.value === props.materialObject.idMaterialInward) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idMaterialInward")
                            }
                            className={props.validState?.error?.idMaterialInward !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Inspected by</label>
                        <MultiSelectDropdown
                            drpIdentity="Select inspect"
                            options={props.materialObject.inspectList}
                            value={props.materialObject.idInspectedBy ? props.materialObject.inspectList.find(x => x.value === props.materialObject.idInspectedBy) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idInspectedBy")
                            }
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Vendor name</label>
                        <MultiSelectDropdown
                            drpIdentity="Select vendor"
                            options={props.materialObject.vendorList}
                            value={props.materialObject.idPartyAccount ? props.materialObject.vendorList.find(x => x.value === props.materialObject.idPartyAccount) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idPartyAccount")
                            }
                            className={props.validState?.error?.idPartyAccount !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp'>
                        <label>Inward date</label>
                        <TextInput type='date'
                            id='inwardDate' name='inwardDate'
                            value={props.materialObject.inwardDate}
                            handleChange={(event) => props.handleChange(event, 'inwardDate')}
                            className={props.validState?.error?.inwardDate !== undefined ? "error" : ""}
                            disabled={true}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Heat no</label>
                        <TextInput type='text'
                            id='heatNo' name='heatNo'
                            value={props.materialObject.heatNo}
                            handleChange={(event) => props.handleChange(event, 'heatNo')}
                            className={props.validState?.error?.heatNo !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Approved by</label>
                        <MultiSelectDropdown
                            drpIdentity="Select approved"
                            options={props.materialObject.approvedList}
                            value={props.materialObject.idApprovedBy ? props.materialObject.approvedList.find(x => x.value === props.materialObject.idApprovedBy) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idApprovedBy")
                            }
                            className={props.validState?.error?.idApprovedBy !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.materialObject.remarks}
                            handleChange={(event) => props.handleChange(event, 'remarks')}
                            className={props.validState?.error?.remarks !== undefined ? "error" : ""}
                        />
                    </div>
                </div>

                <span className="text-blue text-[16px] font-semibold">Material details</span>
                <div className='item-grp grid grid-cols-6 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>

                    <div className='input-grp'>
                        <label>Drawing no</label>
                        <TextInput type='text'
                            id='drawingNo' name='drawingNo'
                            value={props.extraObject.drawingNo}
                            handleChange={(event) => props.handleChangeExtra(event, 'drawingNo')}
                            className={props.validState?.error?.drawingNo !== undefined ? "error" : ""}
                            disabled={true}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Item type</label>
                        <TextInput type='text'
                            id='itemType' name='itemType'
                            value={props.extraObject.itemType}
                            handleChange={(event) => props.handleChangeExtra(event, 'itemType')}
                            className={props.validState?.error?.itemType !== undefined ? "error" : ""}
                            disabled={true}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Item details</label>
                        <TextInput type='text'
                            id='itemDetails' name='itemDetails'
                            value={props.extraObject.itemDetails}
                            handleChange={(event) => props.handleChangeExtra(event, 'itemDetails')}
                            className={props.validState?.error?.itemDetails !== undefined ? "error" : ""}
                            disabled={true}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Inward quantity</label>
                        <TextInput type='number'
                            id='inwardQty' name='inwardQty'
                            value={props.extraObject.inwardQty}
                            handleChange={(event) => props.handleChangeExtra(event, 'inwardQty')}
                            className={props.validState?.error?.inwardQty !== undefined ? "error" : ""}
                            disabled={true}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Reject quantity</label>
                        <TextInput type='number'
                            id='rejectQty' name='rejectQty'
                            value={props.extraObject.rejectQty}
                            handleChange={(event) => props.handleChangeExtra(event, 'rejectQty')}
                            className={props.validState?.error?.rejectQty !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Rework quantity</label>
                        <TextInput type='number'
                            id='reworkQty' name='reworkQty'
                            value={props.extraObject.reworkQty}
                            handleChange={(event) => props.handleChangeExtra(event, 'reworkQty')}
                            className={props.validState?.error?.reworkQty !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Pass quantity</label>
                        <TextInput type='number'
                            id='passQty' name='passQty'
                            value={props.extraObject.passQty}
                            handleChange={(event) => props.handleChangeExtra(event, 'passQty')}
                            className={props.validState?.error?.passQty !== undefined ? "error" : ""}
                            disabled={true}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Status</label>
                        <MultiSelectDropdown
                            drpIdentity="Select material"
                            options={props.extraObject.statusList}
                            value={props.extraObject.status ? props.extraObject.statusList.find(x => x.label === props.extraObject.status) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdownForExtraObject(event, "status")
                            }
                        />
                    </div>
                    <div className='input-grp'>
                        <label>TC</label>
                        <MultiSelectDropdown
                            drpIdentity="Select material"
                            options={props.extraObject.tcList}
                            value={props.extraObject.tc ? props.extraObject.tcList.find(x => x.label === props.extraObject.tc) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdownForExtraObject(event, "tc")
                            }
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Attachment</label>
                        <TextInput type='file'
                            id='attachment' name='attachment'
                            // value={props.extraObject.attachment}
                            handleChange={(event) => props.onFileChange(event, 'attachment')}
                            className={props.validState?.error?.attachment !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp '>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.extraObject.remarks}
                            handleChange={(event) => props.handleChangeExtra(event, 'remarks')}
                            className={props.validState?.error?.remarks !== undefined ? "error" : ""}
                        />
                    </div>
                    {props.extraObject.keyId > 0 ?
                        <button className="save-btn btns py-[10px] px-[20px]" onClick={() => props.insertItem("Update")}>Update</button>
                        : null}
                </div>
                <div className="process-table h-[35vh] mt-5">
                    <div className="table-inner h-full">
                        <AgGridReact
                            ref={gridRef}
                            rowData={props.itemRowData}
                            columnDefs={itemColdefs}
                            overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                            onRowDoubleClicked={props.onItemRowDataClicked}
                            getRowStyle={(params) => {
                                if (params.node.rowPinned) {
                                    return {
                                        fontWeight: 'bold',
                                        background: '#eef6ff'
                                    };
                                }
                            }}
                            rowSelection="multiple"
                            onSelectionChanged={(event) => {
                                const selectedRowsselectedRows = event.api.getSelectedRows();
                                props.onSelectionChanged(selectedRowsselectedRows);
                            }}
                            onRowDataUpdated={(params) => {
                                params.api.selectAll(); 
                            }}
                        />

                    </div>
                </div>
                <div className='total-amt mt-2.5 p-2.5 bg-[#3f8cff1a] rounded-[10px]'>
                    <span className="text-blue text-[16px] font-semibold">Amount details</span>
                    <div className='input-grp-outer grid grid-cols-6 gap-2.5 mt-2.5'>
                        <div className='input-grp'>
                            <label>Total inward quantity</label>
                            <TextInput type='number'
                                id='totalPurchaseQuantity' name='totalPurchaseQuantity'
                                value={props.materialObject.totalPurchaseQuantity}
                                handleChange={(event) => props.handleChangeForPayment(event, 'totalPurchaseQuantity')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Total Approve quantity</label>
                            <TextInput type='number'
                                id='totalPassQuantity' name='totalPassQuantity'
                                value={props.materialObject.totalPassQuantity}
                                handleChange={(event) => props.handleChangeForPayment(event, 'totalPassQuantity')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Total reject quantity</label>
                            <TextInput type='number'
                                id='totalRejectQty' name='totalRejectQty'
                                value={props.materialObject.totalRejectQty}
                                handleChange={(event) => props.handleChangeForPayment(event, 'totalRejectQty')}
                                disabled
                            />
                        </div>

                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()} disabled={props.isSaving}>{props.isSaving ? 'Saving...' : 'Save'}</button>
                    {/* <button className="save-btn btns">Preview</button>
                    <button className="print-btn btns">Print</button>
                    <button className="edit-btn btns">Generate rejection memo</button>
                    <button className="edit-btn btns">Generate rework challan</button> */}
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}